import { X } from 'lucide-react'
import {
  CheckoutShell,
  CheckoutStatusBadge,
} from '@/components/checkout/CheckoutShell'

// PUBLIC, no-auth landing page Stripe Checkout redirects to when the client
// backs out (cancel_url). Static — no API call. Lives OUTSIDE every
// ProtectedRoute (the paying client is not logged into the portal).
export default function CheckoutCancelPage() {
  return (
    <CheckoutShell>
      <CheckoutStatusBadge className='bg-red-100 text-red-600'>
        <X className='h-8 w-8' aria-hidden='true' />
      </CheckoutStatusBadge>
      <h1 className='text-xl font-semibold'>Paiement annulé</h1>
      <p className='text-sm text-muted-foreground'>
        Le paiement n&apos;a pas été effectué. Revenez à l&apos;application pour
        réessayer ou choisir un paiement différé.
      </p>
    </CheckoutShell>
  )
}
